import React, { useState } from "react";
import style from "../style/despesa.module.css";
import { Receita } from "../model/receita";
import Input from "../components/Input";
import Button from "../components/Button";
import { converterParaNumero } from "../function/funcionalidades";
import { useData } from "../function/method_desp_rec";
import Alert from "../components/Alert";
import Saldo from "../components/Saldo";

export default function CadastroReceita() {
  const [nome, setNome] = useState("");
  const [valor, setValor] = useState("");
  const [modal, setModal] = useState(false);

  const [title, setTitle] = useState("");
  const [mensagem, setMensagem] = useState("");

  const { addReceita } = useData();

  const salvarRec = (e) => {
    e.preventDefault();
    if (nome === "" || valor === "") {
      setModal(true);
      setTitle("Erro!");
      setMensagem("Por favor,preencha os campos vazios!");
      return;
    }
    const valorConvet = converterParaNumero(valor);

    let receita = new Receita(nome, valorConvet);
    addReceita(receita);

    setNome("");
    setValor("");
  };

  return (
    <>
      <Saldo />
      <section>
        <div className={style.form}>
          <div className={style.campo}>
            <label htmlFor="nome" className={style.label}>
              Fonte de Renda
            </label>
            <Input
              id="nome"
              placeholder="Ex.: Salário Mínimo"
              valor={nome}
              inputMask={(text) => setNome(text)}
            />
          </div>
          {modal && (
            <Alert
              mensagem={mensagem}
              title={title}
              isOpen={mensagem}
              setOpen={() => setModal(false)}
            />
          )}
          <div className={style.campo}>
            <label htmlFor="valor" className={style.label}>
              Valor
            </label>
            <Input
              id="valor"
              mask="currency"
              placeholder="R$ 0,00"
              valor={valor}
              inputMask={(text) => setValor(text)}
            />
          </div>

          <div className={style.campo}>
            <Button title="Registrar" click={salvarRec} />
          </div>
        </div>
      </section>
    </>
  );
}
